// extracted by css-extract-rspack-plugin
export default {"conversationListHeading":"ConversationList-module__conversationListHeading__Y0f2QRc","inner":"ConversationList-module__inner__aFKPtEE"};